/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AudienceModel from 'cio/models/audience';
import { tracked } from '@glimmer/tracking';

const TAB_NETWORK = {
  id: 'ad_network',
  label: 'Ad Network',
};

const TAB_CONFIGURATION = {
  id: 'configuration',
  label: 'Configuration',
};

// this is shared between several components, can be exported:
export interface ManageAudiencesComponentArgs {
  audience: AudienceModel;
  changeAction: (action: string) => unknown;
  isSaving: boolean;
  onPause: () => Promise<unknown>;
  onDelete: () => Promise<unknown>;
  onClose: () => unknown;
}

export default class Details extends Component<ManageAudiencesComponentArgs> {
  TAB_NETWORK = TAB_NETWORK;
  TAB_CONFIGURATION = TAB_CONFIGURATION;
  tabs = Object.freeze([TAB_NETWORK, TAB_CONFIGURATION]);

  @tracked currentTabId = TAB_NETWORK.id;
}
